module.exports = __webpack_public_path__ + "6e77ef8e2268c551b689d80d21693de6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xld-mn.png
// module id = 2019
// module chunks = 0